import React, { memo, useCallback } from "react";
import { TableFooterProps } from "../types";
import TablePagination from "./TablePagination/TablePagination";

const ROW_SIZE_OPTIONS = [10, 25, 50, 75];

const TableFooter: React.FC<TableFooterProps> = (props) => {
  const { columnCount, onPaginationChange, pagination, isMinimized } = props;

  const handlePageChange = useCallback(
    (pageNumber: number) => {
      if (!onPaginationChange || !pagination) {
        return;
      }

      onPaginationChange({ ...pagination, pageNumber: pageNumber });
    },
    [onPaginationChange, pagination]
  );

  const handleRowPerPageChange = useCallback(
    (rowsNumber: number) => {
      if (!onPaginationChange || !pagination) {
        return;
      }

      onPaginationChange({
        ...pagination,
        pageNumber: 1,
        pageSize: rowsNumber,
      });
    },
    [onPaginationChange, pagination]
  );

  if (!pagination) {
    return null;
  }

  return (
    <tfoot className=" divide-y divide-gray-200 ">
      <tr>
        <td colSpan={columnCount}>
          <TablePagination
            pagination={pagination}
            onChangePage={handlePageChange}
            rowsSizeOptions={ROW_SIZE_OPTIONS}
            onChangeRowsSize={handleRowPerPageChange}
            isMinimized={isMinimized}
          />
        </td>
      </tr>
    </tfoot>
  );
};

export default memo(TableFooter);
